import React from "react";

const dailyActivityBoardRoutes = [
    {
        path: "/dailyActivity/pas/list",
        component: React.lazy(() =>
            import("./pas/PasList")
        ),
    },
    {
        path: "/dailyActivity/pas/:viewType/:appId",
        component: React.lazy(() =>
            import("./pas/PasFormDetails")
        ),
    },
    {
        path: "/dailyActivity/ppap/list",
        component: React.lazy(() =>
            import("./ppap/PpapList")
        ),
    },
    {
        path: "/dailyActivity/ppap/:viewType/:appId",
        component: React.lazy(() =>
            import("./ppap/PpapFormDetails")
        ),
    },
];

export default dailyActivityBoardRoutes;